<style lang="scss" scoped>
.verify {
}
</style>
<template>
    <div class="verify"></div>
</template>

<script>
import { HttpBind } from "@/service/port";
export default {
    data() {
        return {
            type: this.$route.query.usage,
        };
    },
    async created() {
        console.log(this.$route.query);
        // 没有类型，失败
        if (!this.type) {
            this.fail();
        }

        let reqData = {
            ...this.$route.query,
        };
        switch (this.type) {
            // 绑定邮箱
            case "channel_verify":
                if (!reqData.via || !reqData.idlabel || !reqData.verify_token) {
                    return this.fail();
                }
                await HttpBind({
                    ...reqData,
                }).then(
                    (res) => {
                        // this.$VMessage.success(res.message);
                        this.$router.push("/home/sercurity");
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                        setTimeout(this.fail, 3000);
                    }
                );
                break;
            // 邮箱登录
            case "operate_verify":
                if (!reqData.via || !reqData.idlabel || !reqData.verify_token) {
                    return this.fail();
                }
                await HttpVCodeLogin({
                    ...reqData,
                }).then(
                    (res) => {
                        // this.$VMessage.success(res.message);
                        Cookies.set("token", res.data.token, {
                            expires: 14,
                            path: "/",
                            domain: global.DOMAIN,
                        });
                        if (reqData.service) {
                            location.href = service;
                        }
                        else {
                            this.$router.push('home')
                        }
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                        setTimeout(this.fail, 3000);
                    }
                );
        }
    },
    methods: {
        fail() {
            this.$router.push("home");
        },
    },
};
</script>

<style>
</style>